var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.5964C6.07 23.5964 1.25 18.7764 1.25 12.8464C1.25 6.91644 6.07 2.09644 12 2.09644C17.93 2.09644 22.75 6.91644 22.75 12.8464C22.75 18.7764 17.93 23.5964 12 23.5964ZM12 3.59644C6.9 3.59644 2.75 7.74644 2.75 12.8464C2.75 17.9464 6.9 22.0964 12 22.0964C17.1 22.0964 21.25 17.9464 21.25 12.8464C21.25 7.74644 17.1 3.59644 12 3.59644Z",
    fill: "#2F6545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7397 17.1264C10.5497 17.1264 10.3597 17.0564 10.2097 16.9064C9.91969 16.6164 9.91969 16.1364 10.2097 15.8464L13.2097 12.8464L10.2097 9.84641C9.91969 9.55641 9.91969 9.07641 10.2097 8.78641C10.4997 8.49641 10.9797 8.49641 11.2697 8.78641L14.7997 12.3164C15.0897 12.6064 15.0897 13.0864 14.7997 13.3764L11.2697 16.9064C11.1197 17.0564 10.9297 17.1264 10.7397 17.1264Z",
    fill: "#2F6545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/arrow-circle-right.7318724ab3d5f99fddafba14d7a3959b.svg";
export { ForwardRef as ReactComponent };